import { Box } from '@chakra-ui/react';
import { AmountField, Group, Text } from '@melio/penny';
import { Vendor } from '@melio/platform-api';

import { VendorTabAmountCellAmounts } from '../../../types';
import { MIN_AMOUNT_TO_REQUIRE_INVOICE } from '../../../utils';
import { AddInvoiceIndictor } from '../../AddInvoiceIndicator';

type Props = {
  vendors: Vendor[];
  onChange: (vendor: Vendor, value?: string) => void;
  vendorsAmountsMap: VendorTabAmountCellAmounts;
  onAddInvoiceClick: (vendorId: Vendor['id'], amount?: string) => void;
};

export const VendorsBatchPaymentsAmountsModalBody = ({
  vendors,
  onChange,
  vendorsAmountsMap,
  onAddInvoiceClick,
}: Props) => {
  const handleInputChange = (vendor: Vendor, event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(vendor, event.target.value);
  };

  const handleAddInvoiceClick = (vendorId: Vendor['id'], amount?: string) => {
    onAddInvoiceClick(vendorId, amount);
  };

  const renderAddInvoiceIndicator = (vendorId: Vendor['id'], amount?: string) =>
    Number(amount) >= MIN_AMOUNT_TO_REQUIRE_INVOICE ? (
      <AddInvoiceIndictor onAddInvoiceClick={() => handleAddInvoiceClick(vendorId, amount)} vendorId={vendorId} />
    ) : (
      <Box minWidth="24px" />
    );

  return (
    <Group
      spacing="s"
      variant="vertical"
      hasDivider
      data-testid="vendors-batch-payments-amounts-modal-body-vendors-list"
    >
      {vendors.map((vendor) => (
        <Group
          justifyContent="space-between"
          key={vendor.id}
          alignItems="center"
          data-testid={`vendors-batch-payments-amounts-modal-body-row-${vendor.id}`}
        >
          <Text shouldSupportEllipsis>{vendor.name}</Text>
          <Group alignItems="center" spacing="none">
            <Group.Item shrink={0} alignSelf="center">
              {renderAddInvoiceIndicator(vendor.id, vendorsAmountsMap[vendor.id])}
            </Group.Item>
            <Group.Item shrink={0}>
              <AmountField
                size="small"
                data-testid={`vendors-batch-payments-amounts-modal-input-${vendor.id}`}
                onChange={(event) => handleInputChange(vendor, event)}
                allowNegativeValue={false}
              />
            </Group.Item>
          </Group>
        </Group>
      ))}
    </Group>
  );
};
